import { render, staticRenderFns } from "./DevEnvironmentsGuard.vue?vue&type=template&id=4febe676&scoped=true&"
import script from "./DevEnvironmentsGuard.vue?vue&type=script&lang=js&"
export * from "./DevEnvironmentsGuard.vue?vue&type=script&lang=js&"
import style0 from "./DevEnvironmentsGuard.vue?vue&type=style&index=0&id=4febe676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febe676",
  null
  
)

export default component.exports